import { GoogleOAuthProvider } from "@react-oauth/google";
import type { PropsWithChildren } from "react";

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT;
export function Provider({ children }: PropsWithChildren) {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      {children}
    </GoogleOAuthProvider>
  );
}
